import { FETCH_ALL_BLOGS, FETCH_BLOG } from "../types";
import fetchService from "../../../services/fetchService";
import { FETCH_ALL_IMAGES, FETCH_IMAGE } from "../../gallery/types";

const baseUrl = {
  backend: process.env.API_BASE_URL,
};

export const fetchBlogsData = (page) => async (dispatch) =>
  await dispatch({
    type: FETCH_ALL_BLOGS,
    message: `All blogs data`,
    payload: fetchService(`${baseUrl.backend}/api/blogs?page=${page}`),
  });

export const fetchBlogData = (id) => async (dispatch) =>
  await dispatch({
    type: FETCH_BLOG,
    message: `All blog data`,
    payload: fetchService(`${baseUrl.backend}/api/blogs/${id}`),
  });
